import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from '../../util/interceptors';
import { InitDataDTO } from '../component/hornavbar/dto/InitDataDTO';
import { UrlService } from '../../../environments/urlService';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InitStateService {

  private readonly url: string;
  _initDataRefresher = new BehaviorSubject<boolean | null>(null);
  constructor(private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'init-state';
  }

  getInitialData(): Observable<InitDataDTO> {
    return this.http.get<InitDataDTO>(
      this.url + '/data',
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, true), withCredentials: true },
    ).pipe(
      map((initData) => InitDataDTO.deserialize(initData)));
  }

  refreshInitData() {
    this._initDataRefresher.next(true);
  }

  updateSession(): Promise<void> {
    return this.http.post<void>(
      this.url + '/refresh-session', null,
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json' },
    ).toPromise();
  }
}
